import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import ProtectedUnauthorizedItem from './ProtectedUnauthorizedItem';

const sectionConfig = {
  key: LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED.name,
  storeKey: LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED.storeKey,
};

export class ProtectedUnauthorized extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateBranch = this.updateBranch.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasProtectedUnauthorized: this.props.HasProtectedUnauthorized,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasProtectedUnauthorized: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Date);
    const incident = (o.Incident || {}).value ? o.Incident.value : '';

    return Summary({
      type: i18n.t('legal.technology.unauthorized.collection.item'),
      index,
      left: incident,
      right: dates,
      placeholder: i18n.t('legal.technology.unauthorized.collection.unknown'),
    });
  };

  pvqSummary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Date);
    const incident = (o.Incident || {}).value ? o.Incident.value : '';

    return Summary({
      type: i18n.t('legal.pvq.protectedInformation.subsection.unauthorized.summaryItem'),
      index,
      left: incident,
      right: dates,
      placeholder: i18n.t('legal.technology.unauthorized.collection.unknown'),
    });
  };

  render() {
    const { errors, formType } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content legal-technology-unauthorized"
        data-section={LEGAL.key}
        data-subsection={LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED.key}
      >
        <h1 className="section-header">{i18n.t('legal.pvq.protectedInformation.subsection.protected')}</h1>

        <Branch
          {...this.props.HasProtectedUnauthorized}
          name="has_unauthorized"
          label={i18n.t('legal.pvq.protectedInformation.subsection.unauthorized.title')}
          labelSize="h4"
          className="legal-technology-unauthorized-has-unauthorized"
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasProtectedUnauthorized"
        />

        <Show when={this.props.HasProtectedUnauthorized.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.pvqSummary} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('legal.technology.unauthorized.collection.description')}
            appendTitle={i18n.t('legal.pvq.protectedInformation.subsection.unauthorized.appendTitle')}
            appendLabel={i18n.t('legal.pvq.protectedInformation.subsection.unauthorized.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <ProtectedUnauthorizedItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              formType={formType}
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

ProtectedUnauthorized.defaultProps = {
  name: 'unauthorized',
  HasProtectedUnauthorized: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'technology/protectedunauthorized',
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(ProtectedUnauthorized, sectionConfig);
